import { TableColumn } from "../../types";
import { Secret } from "../../../../schema/types/secret/entity";

const secretTypeLabelMap = {
  aws: "AWS",
  "azure-connector": "Azure Connector",
  "azure-sdk": "Azure SDK",
  docker: "Docker",
  dictionary: "Dictionary",
  ecr: "ECR",
  gcp: "GCP",
  keypair: "Keypair",
  "nats-account": "Nats Account",
  opaque: "Opaque",
  tls: "TLS",
  userpass: "Username & Password",
};

const typeDefault = { id: "type", label: "Type" };
export function SecretTypeColumn<TData extends Secret>(column: TableColumn<TData> = typeDefault) {
  const preset: TableColumn<TData> = {
    ...typeDefault,
    size: 210,
    cell: (p) => {
      const secret = p.row.original;
      return <span>{secretTypeLabelMap[secret.type]}</span>;
    },
  };
  return Object.assign(preset, column);
}
